function directive() {
  return (scope, elm, attrs) => {
    elm.on(attrs.stopPropagation, (event) => {
      event.stopPropagation();
    });
  };
}

export default function (ngModule) {
  ngModule.directive('stopPropagation', directive);
}
